import { FC } from 'react';
// components
import ServingSizeComponent from 'components/main/ServingSize/Edit';

const EditServingSize: FC = () => <ServingSizeComponent />;

export default EditServingSize;
